export default {
  menu: {
    SET_CATEGORIES: 'SET_CATEGORIES',
    SET_DISHES: 'SET_DISHES'
  },
  cart: {
    ADD_ITEM: 'ADD_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM',
    REMOVE_LINE: 'REMOVE_LINE',
    CLEAR_CART: 'CLEAR_CART'
  },
  content: {
    SET_PROMOTIONS: 'SET_PROMOTIONS',
    SET_RESTAURANTS: 'SET_RESTAURANTS'
  },
  marketing: {
    SET_SPECIFIC_QUERY_PARAMS_FULLY: 'SET_SPECIFIC_QUERY_PARAMS_FULLY'
  }
}



// WEBPACK FOOTER //
// ./src/store/types.js